<template>
  <v-main>
    <v-container fluid>
      <br />
      <v-row justify="start">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Users'"></span>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            to="/admin/users/create"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <loader v-if="isLoading"></loader>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="min-width: 56px">Sr No</th>
                    <th class="text-left" style="min-width: 65px">Name</th>
                    <th class="text-left" style="min-width: 65px">Email</th>
                    <th class="text-left" style="min-width: 115px">
                      Contact Number
                    </th>
                    <th class="text-left" style="min-width: 57px">Role</th>
                    <th class="text-right" style="min-width: 70px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, i) in users" :key="user.name">
                    <td>{{ i + 1 }}</td>
                    <td style="min-width: 85px">
                      {{ user.first_name }} {{ user.last_name }}
                    </td>
                    <td style="min-width: 150px">{{ user.email }}</td>
                    <td>{{ user.contact_number }}</td>
                    <td style="min-width: 105px">
                      {{
                        user.roles[0].name == "ACADEMIC TEAM"
                          ? "ACADEMIC HEAD"
                          : user.roles[0].name
                      }}
                    </td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/admin/users/${user.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import loader from "@/components/loader.vue";
export default {
  components: { loader },
  name: "UsersPage",
  data() {
    return {
      users: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let users = await axios.get(`users?is_superadmin=true`);
      this.users = users.data.data;
      this.isLoading = false;
    },
  },
};
</script>
